export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Paieška',
  catalogHeaderTitle: 'Išsami informacija',
  catalogDetailsCurtainCopyOptionTitle: 'Kopijuoti nuorodą',
  catalogDetailsLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  catalogDetailsCurtainFlagOptionTitle: 'Pažymėti turinį',
  catalogDetailsFlagCurtainTitle: 'Pažymėti',
  catalogReportedCurtainContent: 'Turinys pažymėtas',
  catalogWantBuy: 'Norite įsigyti {item} iš {app}',
  catalogInterestedIn: '{link}'
}
